<template>
  <div>
    <div v-if="recipeData.prescriptionAuditStatus === 'DISUSED'" class="top-tips disabled">
      <div class="status-text">已作废</div>
    </div>

    <ordonnance v-if="recipeData.id" :ordonnanceData="recipeData" :ordonnanceType="3" class="bg-white"></ordonnance>
    <div class="split-space" v-if="showOperateBtn"></div>
    <footer class="p12 footer-btns fix-bottom fixed-ios bottom-box" v-if="showOperateBtn">
      <van-button type="primary" class="advisory-btn" @click="submit">
        <span class="bold" v-if="recipeData.status === 'UNUSED' && !recipeData.orderId">去付款</span>
        <span class="bold" v-if="recipeData.status === 'USED' || recipeData.orderId">查看订单</span>
      </van-button>
    </footer>
  </div>
</template>

<script>
import ordonnance from './components/customOrdonnance.vue';
import { mapActions } from 'vuex';
import jumpCenter from '@/mixins/jumpCenter';

export default {
  mixins: [jumpCenter],
  data() {
    return {
      recipeData: {},
      preview: false,
      showImage: false,
      prescriptionImgUrl: ''
    };
  },
  components: {
    ordonnance
  },

  computed: {
    showOperateBtn() {
      return (
        !this.preview &&
        this.recipeData.prescriptionAuditStatus &&
        this.recipeData.prescriptionAuditStatus !== 'REJECT' &&
        this.recipeData.prescriptionAuditStatus !== 'EXPIRED' &&
        this.recipeData.prescriptionAuditStatus !== 'DISUSED'
      );
    }
  },

  async created() {
    this.preview = this.$route.query.type == 'preview';
    this.$fetch.getRecipeDetail(this.$route.query.id).then((data) => {
      this.recipeData = data;
    });
    try {
      window.wx.getLocation();
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    ...mapActions(['getUserInfo']),
    submit() {
      this.getUserInfo().then((data) => {
        const { mobile, name, sex, card } = data;
        // 如果已经绑定了，就走下边的逻辑
        if (mobile && name && sex && card) {
          //   this.checkout();
          //   return;
          // }
          // 未使用的处方就会跳转到商城购买，已使用的需要到orderlist
          if (this.recipeData.status === 'UNUSED' && !this.recipeData.orderId) {
            // 这里跳转商城，mixins
            this.$fetch.getRecipeDetail(this.rxId).then((data) => {
              if (data.prescriptionAuditStatus === 'DISUSED') {
                this.$toast('该处方已经作废');
                this.recipeData = data;
                return;
              }
              this.jumpToMallPrescribed(true);
            });
            return;
          } else {
            // 跳转商城的订单列表, 但如果是父订单需要跳转到 订单列表中转页
            this.$fetch
              .fetchIsFatherOrder({ orderId: this.recipeData.orderId })
              .then((res) => {
                if (res === true) {
                  this.$router.push({
                    name: 'fatherOrderList',
                    query: {
                      orderId: this.recipeData.orderId
                    }
                  });
                  // this.jumpToMallFatherOrderDetail(this.recipeData.orderId);
                  return;
                }
                this.jumpToMallOrderDetail(this.recipeData.orderId);
              })
              .catch(() => {
                // do something?
              });
          }
        } else {
          //如果没绑定就走下边的路径
          this.$router.push({
            name: 'BindingInfo',
            query: { jumpUrl: location.href, name: this.recipeData.name ? this.recipeData.name : '' }
          });
        }
      });
    },
    downLoad() {
      const { orderId } = this.recipeData;
      this.$fetch.getRecipeDownUrl({ orderId }).then((data) => {
        this.prescriptionImgUrl = data.prescriptionImgUrl;
        this.showImage = true;
      });

      // http://www.zhiyunyc.com:8889/cache/pres_2415_1504898_118522888.png
    },

    checkout() {
      var ids = this.recipeData.detailModelList.map((ele) => ele.skuId).join(',');
      var nums = this.recipeData.detailModelList.map((ele) => ele.num).join(',');
      var rxId = this.recipeData.id;
      this.$router.push({ name: 'RecipeItemList', query: { ids, nums, rxId } });
    }
  }
};
</script>

<style lang="less" scoped>
.top-tips {
  width: 100%;
  padding: 20px 16px;
  background-color: #1e8dff;
  text-align: center;
  &.disabled {
    background-color: #8c8c8c;
  }
  .status-text {
    font-size: 18px;
    font-weight: 600;
    line-height: 1;
    color: #ffffff;
  }
}
.bg-white {
  padding-bottom: 35px;
}
.split-space {
  height: 60px;
}

.footer-btns {
  width: 100%;
  display: flex;
  background: #fff;
  .prescription-btn {
    flex: 1;
    border-radius: 8px;
    margin-right: 12px;
  }
  .advisory-btn {
    flex: 1;
    border-radius: 8px;
  }
}
.self-pop {
  border-radius: 8px;
  padding: 12px;
  max-height: 80%;
  -webkit-overflow-scrolling: touch;

  overflow: auto;
  .pop-box {
    width: 262px;
    border-radius: 8px;
    .prescription-container {
      width: 100%;
      padding: 10px;
      border: 1px solid #eee;
    }

    .prescription-img {
      width: 100%;
      min-height: 100px;
    }
    .prescription-tip {
      margin: 0 12.5px;
      margin-bottom: 20px;
      background: #e4ecf5;
      border-radius: 18px;
      text-align: center;
      padding: 7px 0;
    }
  }
}
</style>
